import { render, staticRenderFns } from "./question_relates_procedure.vue?vue&type=template&id=bd4d295e&scoped=true"
import script from "./question_relates_procedure.vue?vue&type=script&lang=js"
export * from "./question_relates_procedure.vue?vue&type=script&lang=js"
import style0 from "./question_relates_procedure.vue?vue&type=style&index=0&id=bd4d295e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d295e",
  null
  
)

export default component.exports